import { render, staticRenderFns } from "./PlacesOfService.vue?vue&type=template&id=53e2cb30&scoped=true&"
import script from "./PlacesOfService.vue?vue&type=script&lang=js&"
export * from "./PlacesOfService.vue?vue&type=script&lang=js&"
import style0 from "./PlacesOfService.vue?vue&type=style&index=0&id=53e2cb30&prod&scoped=true&lang=css&"
import style1 from "./PlacesOfService.vue?vue&type=style&index=1&id=53e2cb30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e2cb30",
  null
  
)

export default component.exports